import { useRef, forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Toast as PToast } from 'primereact/toast';
import { IToastr } from './Toast.types';
import styles from './Toast.module.scss';

const LoadingText = 'Loading...';
const InfoSeverity = 'info';

export const Toast = forwardRef<IToastr>((props, ref) => {
  const toastRef = useRef<PToast>(null);

  useImperativeHandle(ref, () => ({
    show: ({ message, rightMessage, severity = InfoSeverity, life = 3000, sticky = false }) => {
      const isInfo = severity === InfoSeverity;
      const detail = message || (isInfo ? LoadingText : '');
      toastRef.current?.show({
        severity,
        detail,
        life: isInfo ? Infinity : life,
        sticky: isInfo || sticky,
        content: (
          <div className={styles['toast-content']}>
            <div className="flex items-center">
              <div className={classNames(styles['toast-icon'], styles[`toast-icon-${severity}`])}></div>
              <span className={styles['toast-message']}>{detail}</span>
            </div>
            <div className="flex items-center">
              {rightMessage && <span className={styles['toast-message']}>{rightMessage}</span>}
              <div className={styles['close-icon']} onClick={() => toastRef.current?.clear()}></div>
            </div>
          </div>
        ),
      });
    },
    clear: () => toastRef.current?.clear(),
  }));

  return <PToast ref={toastRef} position={'bottom-center'} {...props} appendTo={document.querySelector('body')} />;
});

export default Toast;
